import { APIS } from '@/constants';
import axios from 'axios';
import apisHelper from '../helpers/apisHelper';

const tx = {
  /**
   *
   * @param {String} order
   * @param {Number} limit
   * @returns {AxiosPromise}
   */
  requestTxs(order, limit) {
    return axios({
      method: 'get',
      baseURL: APIS.HTTP.BACKEND_TXS,
      params: {
        order: order || undefined,
        limit: limit || undefined,
      },
    });
  },
  /**
   * Get transactions list with query filters
   * @param {Object} parameters - Query filters
   * @param {String|Object} parameters.events - Query string or object for SDK 0.50 format
   * @param {Object} pagination - Pagination options
   * @returns {AxiosPromise}
   * @note SDK 0.50: Query format changed to unified query string
   * Example: { events: "message.action='send' AND tx.height>1000" }
   * Or: { events: { 'message.action': 'send', 'tx.height': '>1000' } }
   */
  requestTxsList(parameters, pagination) {
    let params = {};

    // Handle pagination
    if (pagination) {
      params = apisHelper.setupPagination(pagination);
    }

    // Handle events/query parameter for SDK 0.50
    if (parameters && parameters.events) {
      // Convert events to query format
      params.query = apisHelper.buildTxQuery(parameters.events);

      // Add other parameters (excluding events)
      Object.keys(parameters).forEach((key) => {
        if (key !== 'events' && parameters[key] !== undefined) {
          params[key] = parameters[key];
        }
      });
    } else if (parameters) {
      // No events, just merge other parameters
      Object.assign(params, parameters);
    }

    return axios({
      url: '/txs',
      method: 'get',
      baseURL: APIS.HTTP.TXS,
      params,
    });
  },
  /**
   *
   * @param {String} hash
   * @returns {AxiosPromise}
   */
  requestTxByHash(hash) {
    return axios({
      url: `/txs/${hash}`,
      method: 'get',
      baseURL: APIS.HTTP.TXS,
    });
  },
  /**
   *
   * @param {String} hash
   * @param {String} lcd
   * @returns {AxiosPromise}
   */
  requestTxByHashLegacy(hash, lcd) {
    return axios({
      url: `/txs/${hash}`,
      method: 'get',
      baseURL: lcd,
    });
  },
};

export default tx;
